/**
 * Created by pandemio on 12/20/18.
 */
import React from 'react';
import {Button, Modal, ModalBody, Input} from 'reactstrap';

/** Multiple Language imports **/
import {withLocalize} from "react-localize-redux";
import {renderToStaticMarkup} from 'react-dom/server'; // Fix by the author. Do not remove even if it's not resolved
import {Translate} from "react-localize-redux";
import global from "../../translations/global.json";
/** End of Multiple Language imports **/

import LanguageManager from '../../custom-classes/language-manager';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faHeadset} from '@fortawesome/free-solid-svg-icons';
import Chatbox from '../chat/chatbox';
import socket from '../../components/chat/socket';
/**
 * The form to register new users
 */
class ChatroomClient extends React.Component {

    constructor(props) { // start with a constructor if we want to do modifications on events
        super(props); // Super is required.

        // Declare the properties and set the value according to what we are going to manage in the the page
        this.state = {
            name: null,
            client: socket(),
            modal: false,
            userName: null,
            openChatBox: false,
            chatroomChosen: null
        };

        // To support language library add the following lines
        this.props.initialize({
            languages: [
                {name: "English", code: "en"},
                {name: "Español", code: "es"}
            ],
            options: {renderToStaticMarkup, defaultLanguage: LanguageManager.getLanguage()}
        });
        this.props.addTranslation(global);
        this.callAssistance = this.callAssistance.bind(this);
        this.toggle = this.toggle.bind(this);
        this.enterName = this.enterName.bind(this);
        this.onInput = this.onInput.bind(this);
        this.renderModalName = this.renderModalName.bind(this);
        this.closeChat = this.closeChat.bind(this);
    }

    callAssistance(){
        this.setState({modal: true});
    }

    closeChat(){
        this.state.client.leave(
            this.state.chatroomChosen, (err)=>{
                this.setState({
                    openChatBox: false,
                    userName: null,
                    chatroomChosen: null
                });
        });
    }

    enterName(){
        if(this.state.userName !== null && this.state.userName.length > 0)
        {
            // Set username
            this.setState({openChatBox: true},()=>{
                // Open chat box
                this.state.client.register(this.state.userName, false, (err, name)=>{
                   this.setState({chatroomChosen: name});
                })
            });

            this.toggle();
        }
        else
            this.toggle();
    }

    toggle() {
        this.setState({
            modal: !this.state.modal
        });
    }

    onInput(e) {
        this.setState({
            userName: e.target.value
        });
    }


    renderModalName(){
        return (
            <div>
                <Modal isOpen={this.state.modal} toggle={this.toggle}>
                    <ModalBody>
                        <Translate id="chat.enter-your-name" />
                        <hr/>
                        <p className="text-center">
                            <Input placeholder="..." onChange={this.onInput}
                                   onKeyPress={e => (e.key === 'Enter' ? this.enterName() : null)} />
                        </p>
                        <p className="text-center">
                            <Button onClick={this.enterName}>
                                <Translate id="chat.enter" />
                            </Button>
                        </p>
                    </ModalBody>
                </Modal>
            </div>
        )
    }

    /**
     * Renders the main form element
     * @returns {XML}
     */
    render() {
        return (
           <div>
               <div className="text-center chat-client-button">
                   <Button onClick={this.callAssistance} color="warning" className="white-text">
                       <FontAwesomeIcon icon={faHeadset} size="2x"/>
                       <br/>
                       <Translate id="chat.need-assistance" options={{renderInnerHtml: true}}/>
                   </Button>
                   <br/>
               </div>
               {this.state.modal ?
                    this.renderModalName()
                        : null}

               {this.state.openChatBox && this.state.chatroomChosen !== null ?
                   <div className="chat-client-box-small-resolutions">
                       <Button className="chat-close-button" onClick={this.closeChat}>x</Button>
                    <Chatbox clientSide={true} chatroom={this.state.chatroomChosen} socket={this.state.client} />
                   </div>
                       : null
               }
           </div>
        )
    }
}

export default withLocalize(ChatroomClient);